import { render, staticRenderFns } from "./tabFive.vue?vue&type=template&id=a892f900&scoped=true"
import script from "./tabFive.vue?vue&type=script&lang=js"
export * from "./tabFive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a892f900",
  null
  
)

export default component.exports